"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
const _excluded = ["title", "description"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const loader = _ref => {
  let {
      title,
      description
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? "title-loader" : '') + (description ? " desc-loader" : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-loader"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-loader"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    id: "loader-stroke-line",
    stroke: "url(#loader-gradient)",
    strokeLinecap: "round",
    strokeMiterlimit: "3.376",
    strokeWidth: "3",
    d: "M34 18c0 8.837-7.163 16-16 16S2 26.837 2 18 9.163 2 18 2"
  }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "loader-gradient",
    cx: "0",
    cy: "0",
    r: "1",
    gradientTransform: "rotate(30) scale(5.75,-6) translate(.5, -10)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: ".052",
    stopColor: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: ".208",
    stopColor: "#fff",
    stopOpacity: "0"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: ".25",
    stopColor: "#F26B1C",
    stopOpacity: "0"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#F26B1C"
  }))));
};
var _default = exports.default = loader;